<template>
  <div class="user-wrp-comments example-full">
    <div class="result-bracket__title user__list-count">
      <div class="branch-bar">
        <div class="branch-number">
          <span class="result-bracket__count">{{ dorms.length }} </span> Adet Şube Bulunuyor
        </div>
        <div class="branch-add" v-on:click="goAddPage()" >
          <button class="branch-add__button">
            <p class="branch-add__txt"> YENİ ŞUBE EKLE</p>
            <span class="branch-add__icon">
              <svg-icon type="icon-plus"/>
            </span>
          </button>
        </div>
      </div>

    </div>
    <div class="user__list-offer">
      <div class="user__list-offer__item" v-for="dorm in dorms" :key="dorm.id">

        <div class="user__list-left">
          <div class="user__list-left__box">
                <span >
                  <img
                    :src="dorm.logo" alt=""
                    >
                </span>
          </div>
        </div>

        <div class="user__list-right">
          <div class="user__list-comment-wrp">
            <div class="user__list__dorm">
              <div class="user__list__dorm-img-wrp">
                <span data-v-19f9bfa2="" class="dorm-tab__icon" v-if="dorm.dorm_type_id === '1'">
                  <img
                    src="@/assets/img/icon-male.svg" alt=""
                    class="icon"></span>
                <span data-v-19f9bfa2="" class="dorm-tab__icon" v-if="dorm.dorm_type_id === '2'">
                  <img
                    src="@/assets/img/icon-female.svg" alt=""
                    class="icon"></span>
                <span data-v-19f9bfa2="" class="dorm-tab__icon" v-else>
                  <img
                    src="@/assets/img/icon-male.svg" alt=""
                    class="icon"></span>                                      
              </div>
              <div class="user__list__dorm-wrp">
                <p class="user__list__dorm-name">{{ dorm.name }}</p>
                <div class="user__list__dorm-gen">
                <span class="user__list__dorm-location" v-if="dorm.dorm_type_id === 1">
                Erkek Öğrenci Yurdu</span>
                <span class="user__list__dorm-location" v-if="dorm.dorm_type_id === '2'">
                Kız Öğrenci Yurdu</span>                
                </div>
              </div>
            </div>
          </div>

          <div class="user__list-comment">
            <div class="user__list-link">
              <div class="user__list-bottom">
                Konum :
                <p class="user__list-bottom-title">
                <span class="location-ico">
               <svg-icon type="icon-location"/>
            </span>{{ dorm.city.name }} / {{ dorm.district.name }}
                </p>
              </div>
            </div>
          </div>
        <div class="btn-group" >
                <button class="btn btn-secondary btn-sm dropdown-toggle" type="button">
                  İşlem
                </button>  
                                    <div class="dropdown-menu">
                  <a :class="{'dropdown-item': true, disabled: file.active || file.success || file.error === 'compressing'}" href="#" @click.prevent="file.active || file.success || file.error === 'compressing' ? false :  onEditFileShow(dorm.id)">Düzenle</a>
                  <a :class="{'dropdown-item': true, disabled: !file.active}" href="#" >İptal</a>

                  <a class="dropdown-item" href="#" v-if="file.active" @click.prevent="$refs.upload.update(file, {active: false})">İptal</a>
                  <!-- <a class="dropdown-item" href="#" v-else-if="file.error && file.error !== 'compressing' && $refs.upload.features.html5" @click.prevent="$refs.upload.update(file, {active: true, error: '', progress: '0.00'})">Yükle Tekrar Dene</a>
                  <a :class="{'dropdown-item': true, disabled: file.success || file.error === 'compressing'}" href="#" v-else @click.prevent="file.success || file.error === 'compressing' ? false : $refs.upload.update(file, {active: true})">Yükselt</a> -->

                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" href="#" @click.prevent="$refs.upload.remove(file)">Pasif</a>
                </div>
        </div>       
        </div>
      
            <p>&nbsp;</p>

      </div>
    </div>

         <Modal2 :active="showModal" @onModalClose="closeModal">
          <div slot="content">
        <div class="dorm-form__inner mydorm-form-inner ">
          <div class="dorm-form__form">
            <div class="dorm-form-tab">
              <div icon="icon-mail" class="dorm-form-tab__item mycolor mycursor1">
                <div class="dorm-form-tab__title">Bu yurdu silmek istediğinizden emin misiniz ?</div>
                <!-- <div class="dorfm-form-tab__title">{{ smsarea }} YAKIN TÜM YURTLARDAN TEKLİF AL</div> -->
              </div>
            </div>
            <div id="my-form" ref="myMessageForm">
              <label for="password" v-if="emptyName" class="myValidationText">Bu yurdu silmek istediğinizden emin misiniz ?</label>
            </div>
            <v-button
              class="red fw mt-15 dorm-form__submit mybutton"
              title="Sil"
              @click.native="closeModal()"
            />
            <v-button
              class="green fw mt-10 dorm-form__submit "
              title="Vazgeç"
              @click.native="closeModal()"
            />
          </div>
        </div>
      </div>
    </Modal2>
<!--     <div class="pagination">
      <a href="#" class="pagination__item page-active"><span class="pagination__item-number">1</span></a>
      <a href="#" class="pagination__item"><span class="pagination__item-number">2</span></a>
      <a href="#" class="pagination__item"><span class="pagination__item-number">3</span></a>
      <a href="#" class="pagination__item"><span class="pagination__item-number">4</span></a>
    </div> -->
  </div>
</template>

<script>
import Modal2 from '@/components/Modal2'
import axios from 'axios'
export default {
  name: 'DormBranch',
    components: {
    Modal2
  },
  data () {
    return {
      file: {},
      showModal: false,
      errors: [],
      dorms: [], 
      messages1: [
        {
          id: 0,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Republika Akademik Apart Maslak',
          location: 'İstanbul / Büyükçekmece',
          mail: 'Kız Öğrenci Yurdu',
          hour: '18:15'
        },
        {
          id: 1,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Sema AK',
          location: 'Republika Acedemic Apart Büyükçekmece',
          mail: '@aksema@outlook.com.tr',
          tel: '0539 596 69 76',
          hour: '18:15'

        },
        {
          id: 2,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Sema AK',
          location: 'Republika Acedemic Apart Büyükçekmece',
          mail: '@aksema@outlook.com.tr',
          tel: '0539 596 69 76',
          hour: '18:15'

        },
        {
          id: 3,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Sema AK',
          location: 'Republika Acedemic Apart Büyükçekmece',
          mail: '@aksema@outlook.com.tr',
          tel: '0539 596 69 76',
          hour: '18:15'

        },
        {
          id: 4,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Sema AK',
          location: 'Republika Acedemic Apart Büyükçekmece',
          mail: '@aksema@outlook.com.tr',
          tel: '0539 596 69 76',
          hour: '18:15'

        }
      ]
    }
  },
  methods: {
        closeModal() {
      this.showModal = false
    },
      getCities () {
      let self = this
      axios.get('/site/home/select-cities')
        .then(response => {
          self.cities = response.data
          self.getDorms()
        })
        .catch(e => {
          this.errors.push(e)
        })
    },  
    getDorms () {  
      let self = this
      axios.get(`/dorm/dorms`)
        .then(response => {
          self.dorms = response.data
/*           self.dorms.dataforEach((data) => {
            const city = self.cities.find((city) => city.id == data.city_id)
            data.city_name = city.name
            })  */     
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    deleteDorm() {
      this.showModal = true
    },
    deleteDorm2() {
      this.showModal = false
    },    
    goAddPage() {
      this.$router.push('/yurt-yonetimi/ekle')     
    },
    onEditFileShow(id) {
      window.localStorage.setItem('dorm_id', id)
      this.$router.push('/yurt-yonetimi/duzenle')     
    }    
  },
  created() {
     this.getDorms()
   // this.getCities()
  },
  mounted() {
    this.getDorms()
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/dorm-branch";
  .mybutton{
    width: 20%;
  }

</style>
